module.exports = __webpack_public_path__ + "static/media/icn_review_file.b4810ed5.svg";